import i18n from "@/locale/index.js";
import oUtils from "@/utils/utils";
import { BASE } from "@/config/index";
import * as programApi from "@/services/program/index";
import constant from "@/utils/constant";

import materialCapMock from "@/mock/program/materialCap";
import data from "@/mock/program/programDynamicCap";

class MaterialService {
  constructor() {
    this.oMaterialCap = {
      aShareProperty: [], //存放公共属性能力
      aMaterialType: [], //素材类型
      aIpType: [], //IP类型
      aTranControl: [], //传输控制协议
      aVideoLiveType: [], //视频直播类型
      aStreamType: [], //码流类型
      aMediaServer: [], //流媒体服务器
      aStaticMaterialType: [], //静态素材后缀
      iMaxMaterialName: 32, //素材名称最大长度
      iMaxDescription: 32, //描述最大长度
      aTripartiteType: [],
      aDataType: [],
      aDataBaseType: [],
      aEncodeType: [],
      aDatatableMode: {},
      aTableDataLink: [],
      aTripartiteTypeDef: "",
      aDataTypeDef: "",
      aDataBaseTypeDef: "",
      aEncodeTypeDef: "",
      aTableDataLinkDef: "",
    };
    this.aMaterialData = []; //获取素材列表
    this.oSearchCap = {
      aType: [],
      aApproveState: [],
      aShareProperty: [],
      aStaticMaterialTypeList: [],
      aDynamicMaterialTypeList: [],
      aCollect: [], // 是否收藏
    };
    this.totalMaterial = 0; //素材总数
    this.keepLiveTimer = null; // 定时器

    this.totalNum = 0; //素材全部个数
    this.usedNum = 0; //已被使用个数
    this.unUsedNum = 0; //未被使用个数
  }

  /*
      动态素材类型分为五大类，共七种：
      第一类：1.web （动态素材叫做URL网页，网页是素材是静态，通过本地文件导入）
      第二类：realStream: 2.streamMedia（流媒体）、3.capture（抓图）、4.liveVideo（IPC）
      第三类：generalData：5.popPic（弹图）、6.叫号（call）
      第四类：7.picUrl （URL图片）

      1.4新增一类三方数据源
  */
  async getMaterialCap () {
    // const result = await oWebSdk.WSDK_GetDeviceConfig("materialCap");
    const result = materialCapMock;
    const dynamicMaterialType =
      result?.Data &&
      result?.Data.Material.DynamicMaterial.dynamicMaterialType["@opt"].split(
        ","
      );
    const dynamicMaterialTypeSelf = dynamicMaterialType.filter(
      (x) => x.toString() !== "realStream" && x.toString() !== "generalData"
    );
    const realStreamDestionType =
      result?.Data &&
      result?.Data.Material.DynamicMaterial.RealStream.destionType[
        "@opt"
      ].split(",");
    const tripartiteMaterialType =
      result?.Data && result?.Data.Material.DynamicMaterial.DataSource;
    let realStreamDataType =
      result?.Data &&
      result?.Data.Material.DynamicMaterial.RealStream.dataType["@opt"].split(
        ","
      );
    //const generalDataDataType = oUtils.nodeAttr(xmlDoc, "GeneralData dataType", "opt").split(","); 素材hcp版本暂时不支持叫号、弹图
    const realStreamDestionTypeNotIPC = realStreamDestionType.filter(
      (x) => x.toString() !== "normalIPC"
    );
    realStreamDataType = realStreamDataType.filter(
      (x) => x.toString() !== "capture"
    ); //hcp版本过滤掉抓拍先
    let allDynamicMaterialType = [
      ...dynamicMaterialTypeSelf,
      ...realStreamDestionTypeNotIPC,
      ...realStreamDataType,
      //...generalDataDataType
    ];
    //素材类型
    this.oMaterialCap.aMaterialType = allDynamicMaterialType.map((x) => {
      let obj = {};
      obj.szValue = x.toString();
      obj.szView = i18n.t(obj.szValue);
      x === "document" && (obj.szView = i18n.t("program_document"));
      // 此处的web是动态素材叫做URL网页
      //obj.szView === i18n.t("web") && (obj.szView = "URL" + obj.szView);
      x === "dataSource" && (obj.szView = i18n.t("program_tripartite_data"));
      return obj;
    });
    //判断有无三方数据能力，有的话放到动态素材中配置
    if (
      tripartiteMaterialType &&
      JSON.stringify(tripartiteMaterialType) !== "{}"
    ) {
      try {
        //数据源类别
        this.oMaterialCap.aTripartiteType = this.getTypeArray(
          tripartiteMaterialType?.sourceType["@opt"]?.split(","),
          false,
          "program_"
        );
        this.oMaterialCap.aTripartiteTypeDef =
          tripartiteMaterialType?.sourceType["@def"] || "push";

        //主动推送的数据源类型
        this.oMaterialCap.aDataType = this.getTypeArray(
          tripartiteMaterialType?.dataType["@opt"]?.split(","),
          false,
          "program_"
        );
        this.oMaterialCap.aDataTypeDef =
          tripartiteMaterialType?.dataType["@def"] || "table";

        //数据库类型
        this.oMaterialCap.aDataBaseType =
          tripartiteMaterialType.PullDataInfo?.databaseType["@opt"]
            ?.split(",")
            ?.map((item) => item.trim()) ?? [];
        this.oMaterialCap.aDataBaseTypeDef =
          tripartiteMaterialType.PullDataInfo?.databaseType["@def"] || "MYSQL";

        //数据对接编码格式
        this.oMaterialCap.aEncodeType =
          tripartiteMaterialType.PullDataInfo?.codeType["@opt"]
            ?.split(",")
            ?.map((item) => item.trim()) ?? [];
        this.oMaterialCap.aEncodeTypeDef =
          tripartiteMaterialType.PullDataInfo?.codeType["@def"] || "utf-8";

        //数据表模式
        this.oMaterialCap.aDatatableMode = {
          max:
            (tripartiteMaterialType.PullDataInfo?.tableSchema &&
              tripartiteMaterialType.PullDataInfo.tableSchema["@max"]) ||
            1,
          min:
            (tripartiteMaterialType.PullDataInfo?.tableSchema &&
              tripartiteMaterialType.PullDataInfo.tableSchema["@min"]) ||
            0,
        };
        //表字段对接，数据类型
        this.oMaterialCap.aTableDataLink =
          tripartiteMaterialType.PullDataInfo?.Header?.headerType["@opt"]
            ?.split(",")
            ?.map((item) => item.trim());
        this.oMaterialCap.aTableDataLinkDef =
          tripartiteMaterialType.PullDataInfo?.Header?.headerType["@def"] ||
          "integer";
      } catch (error) {
        console.log(error);
      }
    }

    //共享属性
    this.oMaterialCap.aShareProperty = this.getTypeArray(
      result?.Data && result?.Data.Material.shareProperty["@opt"].split(",")
    );
    //IP类型
    this.oMaterialCap.aIpType = this.getTypeArray(
      result?.Data &&
      result?.Data.Material.DynamicMaterial.RealStream.NormalIPC.IpAddress.ipVersion[
        "@opt"
      ].split(",")
    );
    //码流类型
    this.oMaterialCap.aStreamType = this.getTypeArray(
      result?.Data &&
      result?.Data.Material.DynamicMaterial.RealStream.NormalIPC.streamType[
        "@opt"
      ].split(","),
      false,
      "",
      "_stream"
    );
    //传输控制协议
    this.oMaterialCap.aTranControl = this.getTypeArray(
      result?.Data &&
      result?.Data.Material.DynamicMaterial.RealStream.NormalIPC.transmitProtocol[
        "@opt"
      ].split(","),
      false,
      "program_"
    );

    let _staticTypes = [
      ...(result?.Data &&
        result?.Data.Material.StaticMaterial.picFormat["@opt"].split(",")),
      ...(result?.Data &&
        result?.Data.Material.StaticMaterial.audioFormat["@opt"].split(",")),
      ...(result?.Data &&
        result?.Data.Material.StaticMaterial.videoFormat["@opt"].split(",")),
      // ...result?.Data && result?.Data.Material.StaticMaterial.documentFormat["@opt"].split(","),
      ...(result?.Data &&
        result?.Data.Material.StaticMaterial.pdfFormat["@opt"].split(",")),
      ...(result?.Data &&
        result?.Data.Material.StaticMaterial.webFormat["@opt"].split(",")),
      ...(result?.Data &&
        result?.Data.Material.StaticMaterial.appFormat["@opt"].split(",")),
      ...(result?.Data &&
        result?.Data.Material.StaticMaterial.pptFormat["@opt"].split(",")),
      ...(result?.Data &&
        result?.Data.Material.StaticMaterial.docFormat["@opt"].split(",")),
      ...(result?.Data &&
        result?.Data.Material.StaticMaterial.excelFormat["@opt"].split(",")),
    ];
    let staticMaterialType =
      result?.Data &&
      result?.Data.Material.StaticMaterial.staticMaterialType["@opt"];
    if (staticMaterialType.includes("zip")) {
      _staticTypes.push("zip");
    }
    if (staticMaterialType.includes("font")) {
      _staticTypes.push("otf", "ttf");
    }
    //静态素材后缀
    this.oMaterialCap.aStaticMaterialType = _staticTypes.filter(
      (x) => x.toString() !== "all"
    );
    this.oMaterialCap.iMaxMaterialName =
      result?.Data && result?.Data.Material.materialName["@max"];
    this.oMaterialCap.iMaxDescription =
      result?.Data && result?.Data.Material.materialRemarks["@max"];
  }
  getTypeArray (arr, bHasCheck, sPrefix = "", suffix = "") {
    return arr
      .filter((x) => x.toString() !== "all")
      .map((item) => {
        let obj = {};
        obj.szValue = item.toString();
        if (obj.szValue === "zip" || obj.szValue === "document") {
          obj.szView = i18n.t("program_" + obj.szValue);
        } else if (obj.szValue === "dataSource") {
          obj.szView = i18n.t("program_tripartite_data");
        } else {
          obj.szView = i18n.t(sPrefix + obj.szValue + suffix);
        }
        bHasCheck && (obj.bChecked = false);
        return obj;
      });
  }

  /* 根据条件获取素材列表
   *@method getMaterialList
   *@for MaterialService
   *@param {Object}oSearch 搜索条件可以自定义
   *@return null
   */
  getMaterialList (oSearch, customOptions, applicationType) {
    // const oData = this.createSearchData(oSearch, applicationType);
    const options = {
      showLoading:
        oSearch.showLoading === undefined ? true : oSearch.showLoading,
    };
    Object.assign(options, customOptions);
    return programApi.listMaterialForProgram(oSearch).then(async (result) => {
      console.log(result);
      const data = result;
      this.totalMaterial = data.total;
      this.aMaterialData = data.data || [];
      // this.aMaterialData = this.handlerMaterial(aMaterialData);
      // 并行加载所有缩略图
      // await Promise.all(
      this.aMaterialData.map(async (item) => {
        // const thumbnailUrl = await this.getMaterialThumbnail(
        //   item.thumbnail,
        //   item.materialType
        // );
        // item.materialThumbnailUrl = thumbnailUrl?.data;
        // if (item.materialType === "document") {
        //   item.materialThumbnailUrl = require("@/assets/image/program/document.svg");
        // }
        item.materialThumbnailUrl = this.getMaterialThumbnail(
          item.materialId,
          item.materialType
        );
        item.src = this.getMaterialThumbnail(
          item.materialId,
          item.materialType,
          false
        );
        item.id = item.materialId;
        item.materialType = item.materialType;
        item.materialName = item.fileName;
        item.fileType = item.materialType;
        // 文件实际类型处理
        if (item.materialType === "document") {
          // 不区分类型了，统一按照pdf处理
          // item.fileType = oUtils.getDocumentFileType(item.materialFormat);
          item.fileType = "pdf";
        }
        item.materialShowSize = item.fileSizeFront;
        // item.materialShowSize = oUtils.formatFileSize(item.fileSize);
        item.duration = parseInt(item.duration || 0);
      });
      // );
    });
    // return oWebSdk.WSDK_GetDeviceConfig("materialMoreSearch", null, {
    //   data: oData,
    //   showLoading: options.showLoading,
    //   success: (result) => {
    //     // this.aMaterialData.splice(0);
    //     this.totalMaterial = result?.MaterialSearchResult?.totalMatches || 0;
    //     this.totalNum = result?.MaterialSearchResult?.totalNum || 0;
    //     this.usedNum = result?.MaterialSearchResult?.usedNum || 0;
    //     this.unUsedNum = result?.MaterialSearchResult?.unUsedNum || 0;
    //     this.totalMaterialSize = +(
    //       result?.MaterialSearchResult?.totalMaterialSize || 0
    //     ); //2.0服务端返回的是string类型
    //     this.usedMaterialSize = +(
    //       result?.MaterialSearchResult?.usedMaterialSize || 0
    //     );
    //     this.unUsedMaterialSize = +(
    //       result?.MaterialSearchResult?.unUsedMaterialSize || 0
    //     );
    //     const aMaterialDocData =
    //       result?.MaterialSearchResult?.MaterialList ?? [];
    //     this.aMaterialData = this.handlerMaterial(aMaterialDocData);
    //   },
    // });
  }

  // 处理素材处理参数
  handlerMaterial (aMaterialDocData) {
    let list = [];
    aMaterialDocData.forEach(async (item) => {
      let oMaterial = {};
      oMaterial.id = item.materialId;
      oMaterial.materialType = item.materialType;
      oMaterial.materialName = item.fileName;
      oMaterial.fileType = item.materialType;
      oMaterial.thumbnail = item.thumbnail;

      // const org = oCommonService.aGroup.find(
      //   val => val.id === oUtils.nodeValue(item, "orgNo")
      // );
      // oMaterial.orgName = item.orgName; //所属组织编号
      //org && (oMaterial.orgName = org.name);
      // oMaterial.organizationId = item.orgNo;
      // oMaterial.shareProperty = item.shareProperty;
      // oMaterial.showShareProperty = i18n.t(oMaterial.shareProperty);
      // oMaterial.uploadUser = item.updatedBy;
      // oMaterial.uploadTime = oUtils.transformUTCDatenew(
      //   item.updatedAt,
      //   "format"
      // );
      // oMaterial.materialRemarks = item.materialRemarks;
      // oMaterial.approveState = item.approveState;
      // oMaterial.approveRemarks = item.approveRemarks;
      // oMaterial.collectProperty = item.collectProperty;

      // oMaterial.validityEnable = item?.Validity?.enable ?? false; //是否开启有效期
      // oMaterial.validityBeginTime =
      //   item?.Validity?.beginTime ||
      //   `${new Date().getFullYear()}/${
      //     new Date().getMonth() + 1
      //   }/${new Date().getDate()} 00:00:00`;
      // oMaterial.validityEndTime =
      //   item?.Validity?.endTime ||
      //   `${new Date().getFullYear()}/${
      //     new Date().getMonth() + 1
      //   }/${new Date().getDate()} 23:59:59`;

      // if (oMaterial.materialType === "static") {
      //   //暂时隐藏-yl
      //   let aFormat = [
      //     "picFormat",
      //     "flashFormat",
      //     "audioFormat",
      //     "videoFormat",
      //     "documentFormat",
      //     "pptFormat",
      //     "docFormat",
      //     "excelFormat",
      //     "pdfFormat",
      //     "webFormat",
      //     "appFormat",
      //   ];
      //   let sFormat = aFormat.find(
      //     (value) =>
      //       item.StaticMaterial[value] &&
      //       item.StaticMaterial[value].length
      //   );
      oMaterial.materialFormat = item.materialFormat;
      // oMaterial.materialFormat = $(item).find("staticMaterialType").next().text(); //节点名是动态变化的，只能这么取值了，有点坑
      oMaterial.fileSize = item.fileSize;
      // } else {
      //   let oRealStream = item.DynamicMaterial.RealStream;
      //   let destionType =
      //     oMaterial.fileType === "realStream" ? oRealStream.destionType : ""; //协议必须要这么处理，没办法
      //   let oDataSource = item.DynamicMaterial.DataSource;
      //   if (
      //     oMaterial.fileType === "generalData" ||
      //     destionType === "normalIPC"
      //   ) {
      //     oMaterial.fileType = oRealStream.dataType;
      //   } else if (destionType === "streamMedia") {
      //     oMaterial.fileType = "streamMedia";
      //   }
      //   oMaterial.fileSize = "";
      //   oMaterial.szUrl = item.DynamicMaterial.webUrl;
      //   oMaterial.szPicUrl = item.DynamicMaterial.picUrl;
      //   if (oRealStream) {
      //     oMaterial.szMaterialStreamMedia = oRealStream.streamMediaUrl;
      //     oMaterial.streamMediaType =
      //       oRealStream.streamMediaType || "customUrl";
      //     if (oRealStream.NormalIPC) {
      //       oMaterial.szIpType = oRealStream.NormalIPC.IpAddress.ipVersion;
      //       oMaterial.szIpAddress = oRealStream.NormalIPC.IpAddress.ipAddress;
      //       oMaterial.szPortNum = oRealStream.NormalIPC.portNo;
      //       oMaterial.szChannelNum = oRealStream.NormalIPC.channelNo;
      //       oMaterial.szUsername = oRealStream.NormalIPC.userName;
      //       oMaterial.szTranControl = oRealStream.NormalIPC.transmitProtocol;
      //       oMaterial.szStreamType = oRealStream.NormalIPC.streamType;
      //     }
      //     if (oRealStream.StreamIPC) {
      //       oMaterial.smIpAddress =
      //         oRealStream.StreamIPC?.IpAddress?.ipAddress ||
      //         oRealStream.StreamIPC?.IpAddress;
      //       oMaterial.smPortNum = oRealStream.StreamIPC.portNo;
      //       oMaterial.smUsername = oRealStream.StreamIPC.userName;
      //     }
      //     oMaterial.smChannelNum = 0;
      //   }
      //   if (oDataSource) {
      //     oMaterial.tripartiteType = oDataSource.sourceType;
      //     oMaterial.dataType = oDataSource.dataType;
      //     oMaterial.identification = oDataSource.sourceID;
      //     oMaterial.DataBaseType = oDataSource.PullDataInfo?.databaseType;
      //     oMaterial.encodeType = oDataSource.PullDataInfo?.codeType;
      //     oMaterial.databaseName = oDataSource.PullDataInfo?.databaseName;
      //     oMaterial.databaseIp = oDataSource.PullDataInfo?.ipAddress;
      //     oMaterial.databasePort = oDataSource.PullDataInfo?.port;
      //     oMaterial.databaseUserName = oDataSource.PullDataInfo?.userName;
      //     oMaterial.databasePassword = oDataSource.PullDataInfo?.password;
      //     oMaterial.datatableMode = oDataSource.PullDataInfo?.tableSchema;
      //     oMaterial.dataTableName = oDataSource.PullDataInfo?.tableName;
      //     oMaterial.HeaderList = oDataSource.PullDataInfo?.HeaderList;
      //   }
      // }
      const res = await this.getMaterialThumbnail(
        oMaterial.thumbnail,
        oMaterial.fileType
      );
      oMaterial.materialThumbnailUrl = res?.data;
      oMaterial.materialShowSize = oUtils.formatFileSize(oMaterial.fileSize);
      const thumbnailType = [
        "picture",
        "pdf",
        "video",
        "ppt",
        "excel",
        "doc",
        "font",
      ];
      oMaterial.bSupportThumbnailType = thumbnailType.includes(
        oMaterial.fileType
      );
      // if (oMaterial.materialType === "static") {
      //   oMaterial.duration = item.StaticMaterial.duration;
      // }
      oMaterial.duration = Number(item.duration);

      list.push(oMaterial);
    });
    return list;
  }

  /* 获取单个素材缩略图
   *@method getMaterialThumbnail
   *@for MaterialService
   *@param {iID: inter}素材ID{szType: String}素材类型
   *@return String 缩略图地址
   */
  getMaterialThumbnail (iID, szType, thumbnailImage = true) {
    const thumbnailType = [
      "picture",
      // "pdf",
      "video",
      // "ppt",
      // "excel",
      // "doc",
      // "font",
      ...constant.DOCUMENT_TYPES,
    ]; //只有这些素材类型服务器才会生成缩略图
    if (thumbnailType.includes(szType)) {
      let isThumbnailImage = thumbnailImage;
      // 视频、文档目前只有一个图
      if (["video", ...constant.DOCUMENT_TYPES].includes(szType)) {
        isThumbnailImage = true;
      }
      // 不用接口调用了，直接组装参数返回
      return `${BASE}/content/materialManager/getCommonDownloadUrl?id=${iID}&type=material&thumbnailImage=${isThumbnailImage}`;
      // return 'https://led-picture-bucket.oss-cn-hangzhou.aliyuncs.com/admin-1744085178917-admin-1743665409750-%E7%AF%AE%E7%90%83.jpeg?Expires=1744336941&OSSAccessKeyId=LTAI5tJd62YyDEtGq8gBcG49&Signature=rDmHTF8%2FpW%2B5bGlJg%2BmcK0RrHuY%3D'
    } else {
      // TODO 其他类型素材缩略图
      // if (szType === "document") {
      if (constant.DOCUMENT_TYPES.includes(szType)) {
        return require("@/assets/image/program/document.svg");
      } else if (szType === "audio") {
        return require("@/assets/image/program/audio.svg");
      } else {
        return null;
      }
    }
  }

  getMaterialThumbnailPromise (iID, szType, thumbnailImage = true) {
    return new Promise((resolve, reject) => {
      const thumbnailType = [
        "picture",
        // "pdf",
        "video",
        // "ppt",
        // "excel",
        // "doc",
        // "font",
      ]; //只有这些素材类型服务器才会生成缩略图
      if (thumbnailType.includes(szType)) {
        // 不用接口调用了，直接组装参数返回
        resolve(
          `${BASE}/content/materialManager/getCommonDownloadUrl?id=${iID}&type=material&thumbnailImage=${thumbnailImage}`
        );

        // programApi
        //   .getMaterialDownloadUrl({
        //     bucketName: "led-picture-bucket",
        //     key: iID,
        //   })
        //   .then((res) => {
        //     resolve(res?.data);
        //   })
        //   .catch((e) => {
        //     resolve(null);
        //   });
        // let token = JSEncrypt.createUrlToken();
        // return `${
        //   window.location.pathname
        // }ISAPI/Bumblebee/FocSign/V0/MaterialMgr/Material/Thumbnail/Download?ID=${iID}&MT=GET&timestamp=${new Date().getTime()}&Token=${token}`;
      } else {
        // TODO 其他类型素材缩略图
        // if (szType === "document") {
        if (constant.DOCUMENT_TYPES.includes(szType)) {
          resolve(require("@/assets/image/program/document.svg"));
        } else if (szType === "audio") {
          resolve(require("@/assets/image/program/audio.svg"));
        } else {
          resolve(null);
        }
      }
      // try {
      //   switch (szType) {
      //     case "popPic":
      //       szType = "dynamicPic";
      //       break;
      //     case "liveVideo":
      //       szType = "IPC";
      //       break;
      //     case "capture":
      //       szType = "capturePic";
      //       break;
      //     default:
      //       break;
      //   }
      //   if (szType === "dataSource") {
      //     return require("@/FocSign/assets/img/program/dataSource_sel.svg");
      //   }
      //   let thumbnail = browserCheck.isIE()
      //     ? require("@/FocSign/assets/img/program/" + szType + ".png")
      //     : require("@/FocSign/assets/img/program/" + szType + ".svg");
      //   return thumbnail;
      // } catch (e) {
      //   if (browserCheck.isIE()) {
      //     try {
      //       return require("@/FocSign/assets/img/program/" + szType + ".svg");
      //     } catch (error) {
      //       return require("@/FocSign/assets/img/program/url.svg");
      //     }
      //   }
      //   return require("@/FocSign/assets/img/program/url.svg");
      // }
    });
  }

  getMaterialThumbnailByKey (key) {
    return `${BASE}/content/materialManager/getMaterialDownloadUrl?bucketName=led-picture-bucket${oUtils.isIntl() ? "-intl" : ""}&key=${encodeURIComponent(key)}`;
  }

  getMaterialUrl (materialId, materialType) {
    return programApi.getMaterialDetail({ materialId }).then((res) => {
      if (res.code == 200) {
        return `${BASE}/content/materialManager/getMaterialDownloadUrl?bucketName=led-${materialType}-bucket${oUtils.isIntl() ? "-intl" : ""}&key=${encodeURIComponent(res.data.fileUrl)}`;
      } else {
        return "";
      }
    });
  }
}

let materialService = new MaterialService();
export default materialService;
